interface FilterChipsProps {
  label: string;
  options: string[];
  value: string;
  allLabel?: string;
  onChange: (value: string) => void;
}

export default function FilterChips({
  label,
  options,
  value,
  allLabel = "全部",
  onChange,
}: FilterChipsProps) {
  return (
    <div className="flex items-start gap-3">
      <span className="text-sm text-foreground-500 whitespace-nowrap pt-1.5 w-16 shrink-0">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {["all", ...options].map((opt) => (
          <button
            key={opt}
            type="button"
            onClick={() => onChange(opt)}
            className={`px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
              value === opt
                ? "bg-primary-500 text-background-50 font-medium"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            {opt === "all" ? allLabel : opt}
          </button>
        ))}
      </div>
    </div>
  );
}